<template>
<div class="attributes-edit-wrapper">
    <edit-property-header-block action-label="Edit Attribute" :property-label="name.value">
        <version-selector @versionSelectionChange="handleVersionSelectionChange" class="m-0" :show-label="false"></version-selector>
        <button v-if="canDeleteAttribute" class="btn btn-danger" id="delete_attribute" style="margin-left:10px;" type="submit">Delete Attribute</button>
    </edit-property-header-block>
    <div class="card panel panel-default actions">
        <alert :message="alerts" @clear-alerts="handleUserClearedAlerts"></alert>
        <div class="m-4">
            <attribute-element :custom="name" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element :custom="type" :common="commonData" @changed="loadAttributes" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-option-list v-if="attributesData.type == 'selectbox' || attributesData.type == 'multiselect'"
                                   :attribute-options="attributeOptions"
                                   :attribute-options-meta="attributeOptionsMeta"
                                   :attribute-id="optionId"
                                   :version="versionSelected"
                                   @error="handleAPIerror"
                                   @success="handleAPIsuccess"
                                   @reloadAttributeOptions="loadAttributeOptionsWithLastPageCheck">
            </attribute-option-list>
            <attribute-element :custom="isPublished" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element :description="descriptiveText.isFilterable" :custom="isFilterable" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :description="descriptiveText.displayName" :custom="displayName" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess" class="mb-1"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :description="descriptiveText.slug" :custom="slug" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :description="descriptiveText.length" :custom="length" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :description="descriptiveText.notes" :custom="notes" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :custom="sortOrder" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :custom="isReadOnly" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :custom="isVersionable" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :custom="canView" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>
            <attribute-element v-if="showAdvancedSettings" :custom="canEdit" :common="commonData" @error="handleAPIerror" @success="handleAPIsuccess"></attribute-element>

            <div class="row mt-0 mb-3 p-0 pt-2">
                <div class="offset-1 col-md-11">
                    <button v-if="showAdvancedSettings" type="button" class="btn btn-secondary" @click.stop="showAdvancedSettings = false">Hide Advanced Settings</button>
                    <button v-else  type="button" class="btn btn-secondary" @click.stop="showAdvancedSettings = true">Show Advanced Settings</button>

                    <button v-if="showActivityLog"  type="button" class="btn btn-secondary" @click.stop="showActivityLog = false">Hide Activity Log</button>
                    <button v-else  type="button" class="btn btn-secondary" @click.stop="showActivityLog = true">Show Activity Log</button>
                </div>
            </div>

        </div>
        <div class="m-4" v-if="showActivityLog">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="card-title">Attribute Activity Log</h3>
                </div>
            </div>
            <div class="row mt-0 mb-0 p-0">
                <div class="offset-1 col-md-11">
                    <activity-log entity-type="attribute" :entity-id="optionId" ref="activityLog"></activity-log>
                </div>
            </div>
        </div>
        <div class="load-indicator" v-show="showGeneralLoadIndicator">
            <span class="fa fa-cog fa-spin fa-1x"></span>
        </div>
    </div>
</div>
</template>

<script>

import axios from 'axios';
import VersionSelector from '../generic/version-selector.vue';
import AttributeElement from './attribute-element.vue';
import AttributeOptionList from './attribute-option-list.vue';
import ActivityLog from '../activity/activity.vue';
import Alert from '../generic/alert.vue';
import EditPropertyHeaderBlock from '../generic/edit-property-header-block.vue';

var base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: 'edit-attributes',
    components: {
        'attribute-element': AttributeElement,
        'attribute-option-list': AttributeOptionList,
        'version-selector': VersionSelector,
        'activity-log': ActivityLog,
        'alert': Alert,
        'edit-property-header-block': EditPropertyHeaderBlock,
    },
    props: {
        optionId: String,
        canDeleteAttribute: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showGeneralLoadIndicator: true,
            showActivityLog:false,
            versionSelected: "0",
            attributesData: {},
            attributeOptions: [],
            attributeOptionsMeta: {},
            roles: [],
            showAdvancedSettings: false,
            searchQuery: '',
            resultsPerPage: 7,
            checkForLastPage: false,
            alerts: [],
        }
    },
    computed: {
        descriptiveText() {
            return {
                isFilterable: `Pre-fill search results based on an attribute value`,
                displayName: `The 'Display Name' attribute corresponds to outbound metafield attribute namespaces/keys`,
                slug: `The text key used to identify the attribute, note that this value must be unique and is required for many PIM operations using attributes`,
                length: `Imposes a character limit on the attribute values`,
                notes: `Internal description/note of the attribute`,
                sortOrder: `Controls the display order of the attribute edit list - this can also be accomplished using 'Sort Attributes' Button from the attribute list page`
            }
        },
        name() {
            let r = {label: 'Name', key: 'name', versionKey: 'versionDisplayName', value: '', type: 'short-text', options: [], readOnly: (this.versionSelected != 0)};

                if (this.attributesData.hasOwnProperty('name') && this.attributesData.name != null) {
                    r.value = this.attributesData.name;
                }

            return r;
        },
        type() {
            let r = {label: 'Type', key: 'type', value: '', type: 'single-select', nullSelect: false, readOnly: true,
                options: [
                    {value: 'text', label: 'Simple Text'},
                    {value: 'selectbox', label: 'Selection Box'},
                    {value: 'textarea', label: 'Large Text Area'},
                    {value: 'date', label: 'Date'},
                    {value: 'multiselect', label: 'Multi-Section Box'},
                    {value: 'json', label: 'JSON'},
                    {value: 'markdown', label: 'Markdown'},
                    {value: 'datetime', label: 'Date & Time'}
                ]
            };
            if (this.attributesData.hasOwnProperty('type') && this.attributesData.type != null) {
                r.value = this.attributesData.type;
            }
            return r;
        },
        slug() {
            let r = {label: 'Slug', key: 'slug', value: '', type: 'short-text', options: [], readOnly: (this.versionSelected != 0)};
            if (this.attributesData.hasOwnProperty('slug') && this.attributesData.slug != null) {
                r.value = this.attributesData.slug;
            }
            return r;
        },
        displayName() {
            let r = {label: 'Display Name', key: 'display_name', value: '', type: 'short-text', options: [], readOnly: false};
            if (this.versionSelected == '0') {
                if (this.attributesData.hasOwnProperty('displayName') && this.attributesData.displayName != null) {
                    r.value = this.attributesData.displayName;
                }
            } else {
                if (this.attributesData.hasOwnProperty('versionDisplayName')) {
                    r.value = this.attributesData.versionDisplayName;
                    r.masterValue = this.attributesData.displayName;
                }
            }
            return r;
        },
        //dropped from table
        // userKey() {},
        length() {
            let r = {label: 'Length', key: 'length', value: '', type: 'number', options: [], readOnly: (this.versionSelected != 0)};
            if (this.attributesData.hasOwnProperty('length') && this.attributesData.length != null) {
                r.value = this.attributesData.length + '';
            }
            return r;
        },
        notes() {
            let r = {label: 'Note', key: 'note', value: '', type: 'short-text', options: [], readOnly: (this.versionSelected != 0)};
            if (this.attributesData.hasOwnProperty('note') && this.attributesData.note != null) {
                r.value = this.attributesData.note;
            }
            return r;
        },
        sortOrder() {
            let r = {label: 'Sort Order', key: 'sort_order', value: '', type: 'number', options: [], readOnly: false};
            if (this.versionSelected == '0') {
                if (this.attributesData.hasOwnProperty('sortOrder') && this.attributesData.sortOrder != null) {
                    r.value = this.attributesData.sortOrder + '';
                }
            } else {
                if (this.attributesData.hasOwnProperty('versionSortOrder')) {
                    r.value = this.attributesData.versionSortOrder + '';
                }
            }
            return r;
        },
        isPublished() {
            let r = {label: 'Publish', key: 'publish', value: '', type: 'single-select', nullSelect: false, readOnly: false,
                options: [
                    {value: '0', label: 'No'},
                    {value: '1', label: 'Yes'},
                ]
            };
             if (this.versionSelected == '0') {
                 if (this.attributesData.hasOwnProperty('publish') && this.attributesData.publish != null) {
                     r.value = this.attributesData.publish + '';
                 }
             } else {
                if (this.attributesData.hasOwnProperty('versionPublish')) {
                    r.value = this.attributesData.versionPublish + '';
                    r.masterValue = this.attributesData.publish + '';
                }

             }
            return r;
        },
        isReadOnly() {
            let r = {label: 'Read Only', key: 'readonly', value: '', type: 'single-select', nullSelect: false, readOnly: (this.versionSelected != 0),
                options: [
                    {value: '0', label: 'No'},
                    {value: '1', label: 'Yes'},
                ]
                };
            if (this.attributesData.hasOwnProperty('readonly') && this.attributesData.readonly != null) {
                r.value = this.attributesData.readonly + '';
            }
            return r;

        },
        isFilterable() {
            let r = {label: 'Is filterable?', key: 'is_filterable', value: '', type: 'single-select', nullSelect: false, readOnly: (this.versionSelected != 0),
                options: [
                    {value: '0', label: 'No'},
                    {value: '1', label: 'Yes'},
                ]
                };
            if (this.attributesData.hasOwnProperty('isFilterable') && this.attributesData.isFilterable != null) {
                r.value = this.attributesData.isFilterable + '';
            }
            return r;

        },
        isVersionable() {
            let r = {label: 'Versionable', key: 'translatable', value: '', type: 'single-select', nullSelect: false, readOnly: (this.versionSelected != 0),
                options: [
                    {value: '0', label: 'No'},
                    {value: '1', label: 'Yes'},
                ]
                };
            if (this.attributesData.hasOwnProperty('translatable') && this.attributesData.translatable != null) {
                r.value = this.attributesData.translatable + '';
            }
            return r;

        },
        canView() {
            let r = {label: 'Can View Content', key: 'view_role_ids', value: '', type: 'multi-select', useMultiSelectRoleType: true, readOnly: (this.versionSelected != 0),
                options: this.roles
                };
                r.value = this.attributesData.view_role_ids;

                return r;

        },
        canEdit() {
            let r = {label: 'Can Edit Content', key: 'update_role_ids', value: '', type: 'multi-select', useMultiSelectRoleType: true, readOnly: (this.versionSelected != 0),
                options: this.roles
                };
                r.value = this.attributesData.update_role_ids;
                return r;

        },
        isMaster() {
            return (parseInt(this.versionSelected, 10) === 0);
        },
        isNotMaster() {
            return !this.isMaster;
        },
        commonData() {
            return {
                id: this.attributesData.id,
                selectedVersion: this.versionSelected,
            }
        }
    },
    mounted() {
        this.loadAttributes();
        this.loadRoles();
        this.$events.$on('filter-set', this.handleQueryChange);
    },
    methods: {
        handleAPIsuccess(message) {
            this.updatedActivityLog();
        },
        handleAPIerror(error) {
            //scroll to the top of the screen so the user doesn't miss the message.
            window.scrollTo(0, 0);
            if (error.status == 422) {
                this.alerts = error.message;
            } else {
                this.alerts = ['Unexpected Error!', error.response.status + ' - ' + error.response.statusText, error.response.config.url];
            }
        },
        handleUserClearedAlerts() {
            this.alerts = [];
        },
        handleQueryChange(value) {
            this.searchQuery = value;
            this.loadAttributeOptions();
        },
        handleVersionSelectionChange(newVersion) {
            this.versionSelected = newVersion;
            this.loadAttributes();
            this.loadAttributeOptions();
        },
        loadAttributes() {
            this.showGeneralLoadIndicator = true;
            axios.get(base_url + '/userinterface/attributes/'+this.optionId+'/version/' + this.versionSelected, {})
            .then((response) => {
                this.attributesData = response.data.payload;
                this.showGeneralLoadIndicator = false;
            })
            .catch((error) => {
                this.alerts = ['Unexpected Error!', error.response.status + ' - ' + error.response.statusText, error.response.config.url];
                this.showGeneralLoadIndicator = false;
            });
        },
        updatedActivityLog() {
            if (this.$refs.hasOwnProperty('activityLog')) {
                this.$refs.activityLog.fetchActivity();
            }
        },
        loadRoles() {
            this.showGeneralLoadIndicator = true;
            axios.get(base_url + '/pimapi/roles/', {})
            .then((response) => {
                this.roles = response.data.roles;
                this.showGeneralLoadIndicator = false;
            })
            .catch((error) => {
                console.log('roles load ERROR!');
                this.showGeneralLoadIndicator = false;
            });
        },
        loadAttributeOptionsWithLastPageCheck(forceLastPage) {
            this.checkForLastPage = forceLastPage;
            this.loadAttributeOptions();
        },
        loadAttributeOptions() {
            this.showGeneralLoadIndicator = true;
            //check to see if meta data exists
            let resultPage = 1;
            if (this.attributeOptionsMeta.hasOwnProperty('current_page')) {
                resultPage = this.attributeOptionsMeta.current_page;
            }
            axios.get(base_url + '/userinterface/attributes/' + this.optionId+'/options?page=' + resultPage + '&query='+this.searchQuery + '&per_page=' + this.resultsPerPage, {})
            .then((response) => {
                this.showGeneralLoadIndicator = false;
                this.attributeOptions = response.data.data;
                this.attributeOptionsMeta = response.data.meta;

                //check for out of bounds on page request
                if (response.data.meta.current_page > response.data.meta.last_page) {
                    this.attributeOptionsMeta.current_page = response.data.meta.last_page;
                    this.checkForLastPage = false;
                    this.loadAttributeOptions();
                }

                //check for last page
                if (this.checkForLastPage) {
                    this.checkForLastPage = false;
                    if (response.data.meta.current_page != response.data.meta.last_page) {
                        this.attributeOptionsMeta.current_page = response.data.meta.last_page;
                        this.loadAttributeOptions();
                    }
                }
            })
            .catch((error) => {
                console.log('attributes data load ERROR!');
                this.alerts = ['Unexpected Error!', error.response.status + ' - ' + error.response.statusText, error.response.config.url];
                this.showGeneralLoadIndicator = false;
            });

        }

    }
}
</script>

<style>
.load-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    font-size: 1.5em;
}

</style>
